<template>
<div v-if="this.$route.name != 'logintelegram' && this.$route.name != 'login'  &&  this.$route.name != 'pagenotfound' ">
    <v-app>
        <v-app-bar app class="red darken-0 white--text font-weight-black">
            <!-- <div class="d-flex align-center font-weight-white">

          
       
        </div> -->
            <v-btn v-if="this.$route.path != '/dashboard' " icon @click="backToDasboard()">
                <v-icon color="white">mdi-keyboard-backspace</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <div class="d-flex align-center font-weight-white">

                <div v-if="this.$route.path == '/dashboard'">

                    Menu

                </div>

                <div v-if="this.$route.path == '/clone'">

                    Clone Video

                </div>
                <div v-if="this.$route.path == '/fbvideope'">

                    Power Editor

                </div>
                <div v-if="this.$route.path == '/setting'">

                    Settings

                </div>
                <div v-if="this.$route.path == '/delete'">

                    Auto Delete

                </div>
                <div v-if="this.$route.path == '/viewschedule'">

                    View Schedule

                </div>

            </div>

            <v-spacer></v-spacer>
            <div v-if="this.$route.path == '/dashboard'">
                <!-- ID  :  {{ id }}
          <v-btn class=" white--text font-weight-black" text @click="logout()">
        
            <v-icon class="white--text font-weight-black">mdi-power</v-icon>
    
          </v-btn> -->
                <!-- ID  :  {{ id }} -->

                <!-- <v-icon @click="logout()" class="white--text font-weight-black">mdi-power</v-icon> -->

                <!-- <v-icon @click="gosetting()" class="white--text font-weight-black">mdi-cog</v-icon> -->
                <v-icon @click="getInforUser()" class="white--text font-weight-black">mdi-cog</v-icon>

            </div>

        </v-app-bar>

        <v-main>
            <router-view>

            </router-view>

        </v-main>

        <v-dialog v-model="dialogExtention" persistent max-width="500">

            <v-card>
                <v-card-title style="font-size: 16px;font-weight: bold;">

                    Account Setting
                </v-card-title>

                <v-card-text>
                    <hr>
                    <v-row class="mt-2" style="font-weight: bold;">
                        <v-col cols="6">
                            <p>
                                User ID : {{ id }}
                            </p>
                        </v-col>
                        <v-col cols="6">
                            <p>
                                UserName : {{ user_name }}
                            </p>
                        </v-col>
                        <v-col cols="6">
                            <p>
                                Platform ID : {{ telegram_id }}
                            </p>
                        </v-col>
                        <v-col cols="6">
                            <p>
                                Expired Date : {{ exp_date }}
                            </p>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="dialogExtention=false">
                        Close
                    </v-btn>
                    <!-- <v-btn color="red darken-1 white--text"  @click="logout()">
                        Logout
                    </v-btn> -->
                    <v-btn class="red font-weight-black" @click="logout()">

                        <v-icon class="white--text font-weight-black">mdi-power</v-icon>

                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</div>
<div v-else>

    <router-view>

    </router-view>

</div>
</template>

<script>
import axios from 'axios'
export default {
    name: 'App',

    components: {

    },

    data: () => ({
        //
        dialogExtention: false,
        IsLogin: false,
        value: 0,
        id: "0",
        user_name: '',
        telegram_id: '',
        exp_date: ''
    }),
    created() {

    },
    methods: {
        getInforUser() {

            var user = JSON.parse(localStorage.getItem('info'));
            axios.get('https://app.camsmartbiz.com/user/getinfo/' + user.data.user.id)
                .then((data) => {

                    this.id = data.data.userinfo.data.id
                    this.user_name = data.data.userinfo.data.username;
                    this.telegram_id = data.data.userinfo.data.id_tele;
                    this.exp_date = data.data.userinfo.data.trail_ends_at
                    this.dialogExtention = true
                }).catch((data) => {

                })

        },
        gosetting() {
            this.$router.push('setting').catch(err => {})
        },
        goVideope() {

            this.$router.push('fb-videope').catch(err => {})
        },
        goToCreatePage() {
            this.$router.push('fb-create-page').catch(err => {})
        },
        async login() {

            const googleuser = await this.$gAuth.signIn();

            console.log("User", googleuser);

        },
        logout() {
            localStorage.removeItem('hasLogin')
            localStorage.removeItem('info')
            this.$router.push({
                name: "login"
            });
            this.$store.commit("setAuthentication", false);
        },
        backToDasboard() {
            this.$router.push({
                name: "dashboard"
            });
        }

    },

};
</script>

<style>
@font-face {
    font-family: 'Battambang';

    src: url("https://fonts.googleapis.com/css2?family=Battambang&display=swap");
}

* {
    font-family: Battambang;
}
</style>
